import { addMonths } from "date-fns";

interface PaymentCalculatorProps {
  amountAgreed: number;
  firstPaymentDate: string;
  createdAt: string;
}

export const calculateMonthlyDistribution = (
  monthlyAmount: number,
  paymentDate: Date,
  planCreatedAt: Date
) => {
  // Check if payment is within first 3 months
  const threeMonthsFromStart = addMonths(planCreatedAt, 3);
  const isFirstPeriod = paymentDate <= threeMonthsFromStart;
  
  if (isFirstPeriod) {
    // First 3 months: all money comes to company
    return {
      companyAmount: monthlyAmount,
      creditorAmount: 0,
      isFirstPeriod: true
    };
  } else {
    // After 3 months: 10% to company, 90% to creditors
    return {
      companyAmount: monthlyAmount * 0.1,
      creditorAmount: monthlyAmount * 0.9,
      isFirstPeriod: false
    };
  }
};

export const generatePaymentSchedule = ({ 
  amountAgreed, 
  firstPaymentDate, 
  createdAt 
}: PaymentCalculatorProps) => {
  const startDate = new Date(firstPaymentDate);
  const planCreatedAt = new Date(createdAt);
  const monthlyPayment = amountAgreed; // Monthly payment is the full agreed amount
  const schedule = [];

  // Generate next 6 months of payments for visibility
  for (let i = 0; i < 6; i++) {
    const dueDate = addMonths(startDate, i);
    const { companyAmount, creditorAmount, isFirstPeriod } = calculateMonthlyDistribution(
      monthlyPayment,
      dueDate,
      planCreatedAt
    );

    schedule.push({
      month: i + 1,
      dueDate,
      totalAmount: monthlyPayment,
      companyAmount,
      creditorAmount,
      isFirstPeriod
    });
  }

  return schedule;
};